import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-quantity-selector',
  templateUrl: './quantity-selector.component.html',
  styleUrls: ['./quantity-selector.component.scss'],
})
export class QuantitySelectorComponent implements OnChanges {
  @Input() value: number | null = 0;

  @Input() min = 0;
  @Input() max = 999;
  @Input() step = 1;

  @Input() quickValues: number[] = [1, 5, 10, 20];
  @Input() showStepper = true;
  @Input() disabled = false;

  @Output() valueChange = new EventEmitter<number>();

  // para el input (string)
  displayValue = '0';
  hint = '';

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['value'] || changes['min'] || changes['max']) {
      const v = this.clamp(Number(this.value || 0));
      this.displayValue = String(v);
      this.hint = this.buildHint();
    }
  }

  private buildHint(): string {
    // opcional, puedes devolver '' si no quieres hint
    return `Min ${this.min} · Max ${this.max}`;
  }

  private clamp(n: number): number {
    if (isNaN(n)) n = this.min;
    return Math.max(this.min, Math.min(this.max, n));
  }

  private snapToStep(n: number): number {
    const step = Math.max(1, Number(this.step || 1));
    const base = this.min;
    const snapped = base + Math.round((n - base) / step) * step;
    return this.clamp(snapped);
  }

  setValue(v: number) {
    if (this.disabled) return;
    const nv = this.snapToStep(this.clamp(Number(v)));
    this.value = nv;
    this.displayValue = String(nv);
    this.valueChange.emit(nv);
  }

  inc() {
    if (this.disabled) return;
    this.setValue((this.value || 0) + this.step);
  }

  dec() {
    if (this.disabled) return;
    this.setValue((this.value || 0) - this.step);
  }

  onInput(raw: string) {
    if (this.disabled) return;
    // deja solo dígitos
    const cleaned = (raw || '').replace(/[^\d]/g, '');

    // permitir que el usuario borre temporalmente
    if (cleaned === '') {
      this.displayValue = '';
      return;
    }

    const n = Number(cleaned);
    const clamped = this.clamp(n);

    // actualiza display inmediatamente (sin “snap” agresivo mientras escribe)
    this.displayValue = String(clamped);
    this.value = clamped;
    this.valueChange.emit(clamped);
  }

  onBlur() {
    if (this.disabled) return;
    // al salir, si quedó vacío => min (o 0)
    if (this.displayValue === '') {
      this.setValue(this.min);
      return;
    }

    // al blur sí ajustamos a step para consistencia
    const n = Number(this.displayValue);
    this.setValue(n);
  }
}
